module.exports = __webpack_public_path__ + "static/media/BombaGasolinaEGP20EGP30.3ffd3f15.pdf";